import { render, staticRenderFns } from "./notice-detail.vue?vue&type=template&id=00fd352c&scoped=true&lang=pug&"
import script from "./notice-detail.vue?vue&type=script&lang=js&"
export * from "./notice-detail.vue?vue&type=script&lang=js&"
import style0 from "./notice-detail.vue?vue&type=style&index=0&id=00fd352c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fd352c",
  null
  
)

export default component.exports